import Button from '@mui/material/Button';
import styled from 'styled-components';
import { TButtonBaseProps } from './types';

export const StyledButton = styled(Button)<TButtonBaseProps>``;